import React from 'react';
import { WebsiteDesignProps } from './types';
import { Globe, BookOpen, UserCheck } from 'lucide-react';
import { Button } from "@/components/ui/button";

const InternationalBaccalaureate: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Global IB World School";

    return (
        <div className="bg-white font-sans text-slate-800">
            <div className="bg-[#003e7e] text-white text-xs py-2 text-center font-bold tracking-wide uppercase">
                An IB World School • Empowering Global Citizens
            </div>
            
            <nav className="border-b border-gray-100 py-6 px-8">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-3">
                         <div className="w-10 h-10 rounded-full border-2 border-[#003e7e] flex items-center justify-center text-[#003e7e]">
                             <Globe size={20} />
                         </div>
                         <span className="text-xl font-bold text-[#003e7e] uppercase tracking-tight">{schoolName}</span>
                    </div>
                    <div className="hidden md:flex gap-8 text-sm font-bold text-gray-500 uppercase tracking-tight">
                        <a href="#" className="hover:text-[#003e7e]">PYP</a>
                        <a href="#" className="hover:text-[#003e7e]">MYP</a>
                        <a href="#" className="hover:text-[#003e7e]">Diploma</a>
                        <a href="#" className="hover:text-[#003e7e]">Admissions</a>
                    </div>
                    <Button variant="outline" className="border-[#003e7e] text-[#003e7e] hover:bg-[#003e7e] hover:text-white rounded-full px-6 font-bold text-xs uppercase tracking-wide">
                        Inquire
                    </Button>
                </div>
            </nav>

            <header className="relative h-[500px] flex items-center justify-center bg-slate-100 overflow-hidden">
                <div className="absolute inset-0">
                     <img src="https://images.unsplash.com/photo-1529390003361-593236f8d45f?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-90" alt="Students" />
                     <div className="absolute inset-0 bg-[#003e7e]/80 mix-blend-multiply"></div>
                </div>
                
                <div className="relative z-10 text-center text-white px-4">
                    <h1 className="text-4xl md:text-6xl font-bold mb-4">
                        Inquirers. Knowledgeable. <br/> Caring.
                    </h1>
                    <p className="text-lg md:text-xl opacity-90 mb-8 max-w-2xl mx-auto">
                        Fostering intercultural understanding and respect, preparing students to create a better and more peaceful world.
                    </p>
                    <Button className="bg-white text-[#003e7e] hover:bg-gray-100 font-bold px-8 py-6 rounded-full text-sm uppercase tracking-wider">
                        Discover the IB Difference
                    </Button>
                </div>
            </header>

            <section className="py-20 container mx-auto px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
                    <div className="flex flex-col items-center">
                         <div className="bg-[#f0f7ff] p-6 rounded-full text-[#003e7e] mb-6">
                             <Globe size={32} />
                         </div>
                         <h3 className="text-xl font-bold text-[#003e7e] mb-3">Global Perspective</h3>
                         <p className="text-gray-500 leading-relaxed px-4">A curriculum that connects local issues to global contexts, encouraging multilingualism.</p>
                    </div>
                    <div className="flex flex-col items-center">
                         <div className="bg-[#f0f7ff] p-6 rounded-full text-[#003e7e] mb-6">
                             <UserCheck size={32} />
                         </div>
                         <h3 className="text-xl font-bold text-[#003e7e] mb-3">Holistic Growth</h3>
                         <p className="text-gray-500 leading-relaxed px-4">Developing not just the intellect, but the physical, emotional, and social well-being.</p>
                    </div>
                    <div className="flex flex-col items-center">
                         <div className="bg-[#f0f7ff] p-6 rounded-full text-[#003e7e] mb-6">
                             <BookOpen size={32} />
                         </div>
                         <h3 className="text-xl font-bold text-[#003e7e] mb-3">Rigorous Academics</h3>
                         <p className="text-gray-500 leading-relaxed px-4">Challenging programs that are recognized and respected by universities worldwide.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default InternationalBaccalaureate;
